(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.MultiDeleteDialog = (function(superClass) {
    extend(MultiDeleteDialog, superClass);

    function MultiDeleteDialog() {
      return MultiDeleteDialog.__super__.constructor.apply(this, arguments);
    }

    MultiDeleteDialog.prototype.init = function() {
      this.layoutSource = $('.multidelete-dialog');
      this.layoutUrl = null;
      this.defaultSave = false;
      this.classes = 'small_dialog';
      this.modalOptions = {
        backdrop: true
      };
      return this.createDialog();
    };

    MultiDeleteDialog.prototype.afterLoadLayout = function() {
      var i, len, msgwriter, ref, ths, v;
      ths = this;
      msgwriter = this.dialog.find('.message_writer');
      msgwriter.message_writer({
        autoHide: false
      });
      if (this.saveData.objects != null) {
        this.dialog.find('.multidelete-num').text(this.saveData.objects.length);
        ref = this.saveData.objects;
        for (i = 0, len = ref.length; i < len; i++) {
          v = ref[i];
          this.dialog.find('.multidelete-items').append(v.name + "<br />");
        }
      }
      this.saveAction = (function(_this) {
        return function() {
          var completed, j, len1, msgdata, ref1, ref2, results, successful, total, url;
          if (msgwriter.length !== 0 && $.contains(document, msgwriter[0])) {
            msgwriter.message_writer('info', 'Deleting...');
          }
          total = _this.saveData.objects.length;
          completed = 0;
          successful = 0;
          msgdata = {
            status: {
              type: null,
              msg: null
            },
            data: {
              messages: {}
            }
          };
          ref1 = _this.saveData.objects;
          results = [];
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            v = ref1[j];
            url = (ref2 = v.url) != null ? ref2 : _this.saveUrl;
            results.push($.ajax({
              type: 'post',
              url: url,
              obj_data: v,
              data: {
                id: v.id,
                extra: v.element.data()
              },
              success: function(data) {
                var errs, ref3, status;
                v = this.obj_data;
                if (data.status != null) {
                  if (data.status.type === 'success') {
                    v.element.remove();
                    successful++;
                    ths.multi_widget.element.trigger('deleteOneSuccess', data);
                  } else {
                    msgdata.data.messages["" + v.id] = v.name + " - " + data.status.msg;
                    if (((ref3 = data.data) != null ? ref3.messages : void 0) != null) {
                      msgdata.data.messages["" + v.id] = (v.name + "<br />") + ths.listMessages(data.data.messages);
                    }
                    ths.multi_widget.element.trigger('deleteOneFailure', data);
                  }
                  completed++;
                } else {
                  completed++;
                  errs = msgdata.data.messages["" + v.id] = v.name + " could not be deleted";
                  ths.multi_widget.element.trigger('deleteOneFailure', data);
                }
                if (completed === total) {
                  if (successful > 0) {
                    ths.triedSave = true;
                  }
                  status = {};
                  status.count = {};
                  if (successful === total) {
                    status.status = 'success';
                    status.count.success = total;
                    status.count.failure = 0;
                    ths.multi_widget.element.trigger('deleteAllComplete', status);
                    msgdata.status.type = 'success';
                    msgdata.status.msg = total + " items deleted successfully";
                    ths.multi_widget._cleanUp();
                  } else {
                    msgdata.status.type = 'error';
                    msgdata.status.msg = 'The following errors were encountered:';
                    status.status = 'failure';
                    status.count.success = successful;
                    status.count.failure = completed - successful;
                  }
                  return ths.afterSave(msgdata);
                }
              }
            }));
          }
          return results;
        };
      })(this);
      this.afterHidden = (function(_this) {
        return function() {
          return _this.multi_widget._cleanUp();
        };
      })(this);
      return this.openDialog();
    };

    MultiDeleteDialog.prototype.submitAction = function() {
      return this.save('');
    };

    return MultiDeleteDialog;

  })(DialogHandler);

}).call(this);
